import { render } from "./diretorAdd.vue?vue&type=template&id=08ea0b6c"
import script from "./diretorAdd.vue?vue&type=script&lang=js"
export * from "./diretorAdd.vue?vue&type=script&lang=js"

import "./diretorAdd.vue?vue&type=style&index=0&id=08ea0b6c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__